<div class="tab-pane" role="tabpanel" id="independiente">
    <fieldset id="agregar_independiente" class="">
        <div class="step_section">
            <h3 class="form-signin-heading"><strong>Informaci&oacute;n de los independientes</strong></h3>
            <hr>
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <p>Ingrese el RUT para agregar independiente</p>
                    <div class="form-horizontal">
                        <div class="form-group">
                            <label for="rut_ind" class="col-md-1" style="padding-top: 15px">RUT</label>
                            <div class="col-md-2">

                                <form [formGroup]="rut_ind">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Rut" id="rut_ind" name="rut_ind" formControlName="rut" formatRut [errorStateMatcher]="matcher">
                                        <mat-error *ngIf="rut_ind && rut_ind.controls?.rut.hasError('invalidRut')">
                                            Este rut es <strong>invalido</strong>
                                        </mat-error>

                                    </mat-form-field>
                                </form>

                            </div>
                            <div class="col-md-2">
                                <button mat-raised-button color="primary" style="padding-top: 5px" id="b_rut_ind" [disabled]="!rut_ind.valid" (click)="get_independiente(rut_ind.controls.rut.value)">
                                            Agregar Independiente
                                    <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!--Detalle de los independientes-->
                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>RUT</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.rut | rut}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>NOMBRE</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span>{{row.nombre}}</span><span> {{row.apellido_pat}}</span><span> {{row.apellido_mat}}</span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    <span (click)="update_independiente(row.rut,rowIndex)" style="padding-right: 5px;"><i class="glyphicon glyphicon-eye-open"></i></span>
                                    <span (click)="delete_independiente(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>

                        </ngx-datatable>
                    </div>
                </div>

            </div>
        </div>
    </fieldset>
    <!-- Modal -->
    <ng-template #openModal>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n del Independiente</h2>
        <mat-dialog-content>

            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion del independiente</strong>, su solicitud pasar&aacute; por un proceso de verificaci&oacute;n del independiente ingresado. <br>
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                    <strong> Campos obligatorios marcados con un (<span style="color: red">*</span>)</strong>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="rut">RUT(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="rut" name="rut" type="text" placeholder="RUT" class="form-control input-md" [(ngModel)]="independiente.rut" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="nombre_independ" [hidden]="!isNatural">Raz&oacute;n Social(<span style="color: red">*</span>)</label>
                    <label class="col-md-4 control-label" for="nombre_independ" [hidden]="isNatural">Nombre(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="nombre_independ" name="nombre_independ" type="text" placeholder="Nombre o Raz&oacute;n Social" [(ngModel)]="independiente.nombre" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div id="hide-ind-enterprise" [hidden]="!isNatural">
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="apelpat_independ">Apellido Paterno</label>
                        <div class="col-md-6">
                            <input id="apelpat_independ" name="apelpat_independ" type="text" placeholder="Apellido Paterno" [(ngModel)]="independiente.apellido_pat" class="form-control input-md">
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="apelmat_independ">Apellido Materno</label>
                        <div class="col-md-6">
                            <input id="apelmat_independ" name="apelmat_independ" type="text" placeholder="Apellido Materno" [(ngModel)]="independiente.apellido_mat" class="form-control input-md">
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </div>
                <div [hidden]="!isNatural">
                    <div class="form-group">
                        <div class="col-md-1"></div>
                        <label class="col-md-2 control-label" for="dir_calle_independ">Direcci&oacute;n Calle(<span style="color: red">*</span>)</label>
                        <div class="col-md-3">
                            <input id="dir_calle_independ" name="dir_calle_independ" type="text" placeholder="Calle" [(ngModel)]="independiente.direccion" class="form-control input-md">
                        </div>
                        <label class="col-md-2 control-label" for="dir_num_independ">Direcci&oacute;n Numero(<span style="color: red">*</span>)</label>
                        <div class="col-md-3">
                            <input id="dir_num_independ" name="dir_num_independ" type="text" placeholder="Numero" [(ngModel)]="independiente.direccion_num" class="form-control input-md">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-1"></div>
                        <label class="col-md-2 control-label" for="dir_comp_independ">Direcci&oacute;n Complemento</label>
                        <div class="col-md-3">
                            <input id="dir_comp_independ" name="dir_comp_independ" type="text" placeholder="Complemento" [(ngModel)]="independiente.direccion_complemento" class="form-control input-md">
                        </div>
                        <div class="col-md-5">
                            <label class="col-md-5 control-label" for="comuna">Comuna(<span style="color: red">*</span>) </label>
                            <div class="col-md-7">
                                <mat-form-field class="example-full-width">
                                    <input type="text" id="Com_nombre" name="Com_nombre" aria-label="Nombre" matInput [formControl]="nombreComuna" [matAutocomplete]="auto" [(ngModel)]="independiente.comuna">
                                    <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                        {{option}}
                                    </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <!-- <input id="comuna" name="comuna" type="text" placeholder="Comuna" [(ngModel)]="propietario.comuna" class="form-control input-md"> -->
                            </div>
                            <div class="col-md-2"></div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="fono_independ">Tel&eacute;fono</label>
                    <div class="col-md-6">
                        <input id="fono_independ" name="fono_independ" type="text" placeholder="Tel&eacute;fono" [(ngModel)]="independiente.fono" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="email_independ">Email(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="email_independ" name="email_independ" type="email" placeholder="mail@ejemplo.com" [(ngModel)]="independiente.mail" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <!-- <div class="form-group">
                    <label class="col-md-4 control-label" for="patente_independ">Patente</label>
                    <div class="col-md-6">
                        <input id="patente_independ" name="patente_independ" type="text" placeholder="patente" [(ngModel)]="independiente.patente" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div> -->
                <div class="form-group">
                    <label class="col-md-4 control-label" for="categoria_independ">Categoria</label>
                    <div class="col-md-6">
                        <input id="categoria_independ" name="categoria_independ" type="text" placeholder="categoria" [(ngModel)]="independiente.categoria" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="registro_independ">Registro</label>
                    <div class="col-md-6">
                        <input id="registro_independ" name="registro_independ" type="text" placeholder="registro" [(ngModel)]="independiente.registro" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_independ" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id=" ingreso_independ" (click)="saveIndependiente() " [disabled]="!independiente.mail || !independiente.direccion || !independiente.direccion_num || !independiente.comuna || !independiente.nombre || !independiente.rut">Ingresar Independiente <i class="fa fa-user-o " aria-hidden="true "></i></button>

        </mat-dialog-actions>
    </ng-template>
    <!--End Material Dialog-->
</div>


<div class="separator"></div>